module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-right-arrow-gray-dark-on-white-75a57910ec1357b67b8640dfc4df961f.svg";